module.exports = __webpack_public_path__ + "img/ui_hotspot_0060.297c4207.png";